<div class="panel">
  <div class="panel__group">
    <div class="panel__search">
      <app-button
        type="button"
        color="return"
        icon="agres-return"
        (btnClick)="backToUtilities()"
        title="{{ 'global.back' | translate }}"></app-button>
    </div>
  </div>
</div>

<header class="pwm-spray-calculator__header">
  <p class="pwm-spray-calculator__subtitle">{{ 'pwm-calculator-page.subtitle' | translate }}</p>
</header>

<div class="pwm-spray-calculator">
  <form
    class="pwm-spray-calculator__form"
    [formGroup]="form"
    (ngSubmit)="onCalculate()"
    aria-labelledby="pwm-form-title">
    <h2 id="pwm-form-title" class="pwm-spray-calculator__section-title">
      {{ 'pwm-calculator-page.form-title' | translate }}
    </h2>

    <div class="pwm-spray-calculator__field">
      <label class="pwm-spray-calculator__label" for="nozzleIndex">
        {{ 'pwm-calculator-page.nozzle-label' | translate }}
      </label>
      <!-- ng-select instead of a native select: Safari ignores select padding and no browser paints swatches inside native options -->
      <ng-select
        labelForId="nozzleIndex"
        class="pwm-spray-calculator__nozzle"
        formControlName="nozzleIndex"
        bindValue="index"
        [items]="nozzleOptions"
        [searchable]="false"
        [clearable]="false">
        <ng-template ng-label-tmp let-item="item">
          <ng-container [ngTemplateOutlet]="nozzleOption" [ngTemplateOutletContext]="{ $implicit: item.nozzle }" />
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <ng-container [ngTemplateOutlet]="nozzleOption" [ngTemplateOutletContext]="{ $implicit: item.nozzle }" />
        </ng-template>
      </ng-select>
      <ng-template #nozzleOption let-nozzle>
        <span class="pwm-spray-calculator__nozzle-option">
          <span class="pwm-spray-calculator__nozzle-swatch" [style.background]="nozzle.color"></span>
          <span class="pwm-spray-calculator__nozzle-text">
            {{ nozzle.name }} - {{ formatFlow(nozzle.flow) }} {{ 'pwm-calculator-page.flow-unit' | translate }}
          </span>
        </span>
      </ng-template>
    </div>

    <div class="pwm-spray-calculator__field">
      <label class="pwm-spray-calculator__label" for="targetRate">
        {{ 'pwm-calculator-page.target-rate-label' | translate }}
      </label>
      <div
        class="pwm-spray-calculator__input-suffix"
        [attr.data-suffix]="'pwm-calculator-page.target-rate-suffix' | translate">
        <input
          id="targetRate"
          class="pwm-spray-calculator__input"
          type="text"
          inputmode="decimal"
          autocomplete="off"
          formControlName="targetRate"
          (blur)="normalizeInput('targetRate')" />
      </div>
    </div>

    <div class="pwm-spray-calculator__field">
      <label class="pwm-spray-calculator__label" for="spacingCm">
        {{ 'pwm-calculator-page.spacing-label' | translate }}
      </label>
      <div
        class="pwm-spray-calculator__input-suffix"
        [attr.data-suffix]="'pwm-calculator-page.spacing-suffix' | translate">
        <input
          id="spacingCm"
          class="pwm-spray-calculator__input"
          type="text"
          inputmode="decimal"
          autocomplete="off"
          formControlName="spacingCm"
          (blur)="normalizeInput('spacingCm')" />
      </div>
    </div>

    <div class="pwm-spray-calculator__grid">
      <div class="pwm-spray-calculator__field">
        <label class="pwm-spray-calculator__label" for="pressureMin">
          {{ 'pwm-calculator-page.pressure-min-label' | translate }}
        </label>
        <div
          class="pwm-spray-calculator__input-suffix"
          [attr.data-suffix]="'pwm-calculator-page.pressure-suffix' | translate">
          <input
            id="pressureMin"
            class="pwm-spray-calculator__input"
            type="text"
            inputmode="decimal"
            autocomplete="off"
            formControlName="pressureMin"
            (blur)="normalizeInput('pressureMin')" />
        </div>
      </div>

      <div class="pwm-spray-calculator__field">
        <label class="pwm-spray-calculator__label" for="pressureMax">
          {{ 'pwm-calculator-page.pressure-max-label' | translate }}
        </label>
        <div
          class="pwm-spray-calculator__input-suffix"
          [attr.data-suffix]="'pwm-calculator-page.pressure-suffix' | translate">
          <input
            id="pressureMax"
            class="pwm-spray-calculator__input"
            type="text"
            inputmode="decimal"
            autocomplete="off"
            formControlName="pressureMax"
            (blur)="normalizeInput('pressureMax')" />
        </div>
      </div>
    </div>

    <div class="pwm-spray-calculator__actions">
      <app-button
        type="submit"
        color="primary"
        size="full"
        icon="agres-tool"
        title="{{ 'pwm-calculator-page.calculate-button' | translate }}"></app-button>
    </div>
  </form>

  <section class="pwm-spray-calculator__results" aria-labelledby="pwm-results-title" aria-live="polite">
    <h2 id="pwm-results-title" class="pwm-spray-calculator__section-title">
      {{ 'pwm-calculator-page.results-title' | translate }}
    </h2>
    <div class="pwm-spray-calculator__result-list">
      <div class="pwm-spray-calculator__result-item">
        <div class="pwm-spray-calculator__result-label">
          {{ 'pwm-calculator-page.result-min-speed-label' | translate }}
        </div>
        <div class="pwm-spray-calculator__result-value">
          {{ formatSpeed(result?.minSpeedKmh) }}
          <span class="pwm-spray-calculator__result-unit">{{ 'pwm-calculator-page.speed-unit' | translate }}</span>
        </div>
      </div>
      <div class="pwm-spray-calculator__result-item">
        <div class="pwm-spray-calculator__result-label">
          {{ 'pwm-calculator-page.result-max-speed-label' | translate }}
        </div>
        <div class="pwm-spray-calculator__result-value">
          {{ formatSpeed(result?.maxSpeedKmh) }}
          <span class="pwm-spray-calculator__result-unit">{{ 'pwm-calculator-page.speed-unit' | translate }}</span>
        </div>
      </div>
    </div>
  </section>
</div>
